import type { ReactNode } from "react";

/**
 * The gradient S, inlined.
 *
 * Inline rather than `<img src="/favicon.svg">` so it inherits `.brand-mark`'s
 * sizing and can never render at a different size per site — which is exactly
 * how one site ended up with a 1.75rem mark and no wordmark below 1024px.
 *
 * The gradient id is a constant, matching the marketing markup. Two marks on
 * one page (header and footer) reuse the same gradient definition, which is
 * correct: duplicate <defs> with the same id would be the bug.
 */
export function BrandMark({ className = "brand-mark" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 40 40" role="img" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="logoGradNav" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ff9153" />
          <stop offset="1" stopColor="#ff7a23" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="11" fill="#1a1a1a" />
      <path
        d="M13 26.2c0 3 2.6 4.9 6.3 4.9 4.3 0 6.9-2 6.9-5.1 0-2.9-2-4.2-5.9-5.1l-1.6-.4c-1.6-.3-2.3-.9-2.3-1.9 0-1.2 1.2-2 3-2 1.9 0 3.1.9 3.3 2.3h4.8c-.3-3.5-3-5.6-7.9-5.6-4.6 0-7.7 2.1-7.7 5.4 0 2.7 1.9 4.2 5.6 5.1l1.6.4c1.9.5 2.7 1 2.7 2.1 0 1.3-1.3 2-3.3 2-2.2 0-3.5-.8-3.7-2.3H13Z"
        fill="url(#logoGradNav)"
      />
    </svg>
  );
}

/** The full lockup: mark + wordmark, at every width, on every route. */
export function Brand({ children }: { children?: ReactNode }) {
  return (
    <>
      <BrandMark />
      <span>{children ?? "Shoku"}</span>
    </>
  );
}
